import { Link, useLocation } from 'react-router-dom'

/**
 * In-app 404 — rendered inside the shell for any route that doesn't exist, instead of
 * silently bouncing to /accounts (which made a mistyped link look like a redirect bug).
 */
export function NotFound() {
  const { pathname } = useLocation()

  return (
    <div className="wrap">
      <div className="panel" style={{ maxWidth: 560, margin: '60px auto', padding: '34px 36px' }}>
        <div className="eyebrow">404 — Not found</div>
        <h1 className="disp" style={{ fontSize: 28, margin: '8px 0' }}>
          This page doesn&rsquo;t exist
        </h1>
        <p className="lede" style={{ fontSize: 14.5, marginBottom: 24 }}>
          Nothing lives at <code>{pathname}</code>. The link may be out of date, or the address
          mistyped.
        </p>
        <Link to="/accounts" className="genbtn" style={{ margin: 0, textDecoration: 'none' }}>
          <i className="ti ti-arrow-left" style={{ fontSize: 17 }} /> Back to accounts
        </Link>
      </div>
    </div>
  )
}
